// 反思日记单个分享
import React, { useEffect, useState } from 'react';
import { useRouteMatch, useHistory, useLocation, useParams } from "react-router-dom";
import { Modal, Toast } from 'antd-mobile';
import classnames from 'classnames';
import '../css/RikeNoteShare.scss';
import RikeService from '../services/Rike';
import { getWeek, getParameter, getCookie, weekGetDate, weekDate } from '../utils/func';
import moment from 'moment';
import NoteShare from '../services/NoteShare';

const RikeNoteShare = ({ props }) => {
    const match = useRouteMatch();
    const location = useLocation();
    const history = useHistory();
    const params = useParams();
    const APPID = 'wx754e1b2a81936e91' // appid
    // console.log(match, location, history, params);
    const [noteDetail, setNoteDetail] = useState({ note: {}, note_childs: [] });
    const [isShow, setIsShow] = useState(false);
    const [user, setUser] = useState({});
    const [orderData, setOrderData] = useState({});
    const [timer, setTimer] = useState(null);
    useEffect(() => {
        RikeService.getArticleDetail({ uuid: params.id }).then(res => {
            // document.title = res.data.title;
            setNoteDetail(res.data);
            setIsShow(true);
        }).catch(error => { error.message && Toast.info(error.message); setIsShow(false) })
        const themeColor = getParameter('themeColor', location.search);
        document.body.style.setProperty('--themeColor', themeColor ? '#' + themeColor : '#F7B501');
    }, []);
    const browser = {
        versions: function () {
            var u = navigator.userAgent, app = navigator.appVersion;
            return {
                trident: u.indexOf('Trident') > -1, //IE内核
                presto: u.indexOf('Presto') > -1, //opera内核
                webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
                gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,//火狐内核
                mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
                ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
                android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 || u.indexOf('Linux') > -1, //android终端
                iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
                iPad: u.indexOf('iPad') > -1, //是否iPad
                webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
                souyue: u.indexOf('souyue') > -1,
                superapp: u.indexOf('superapp') > -1,
                weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
                qq: u.match(/\sQQ/i) == " qq", //是否QQ
                Safari: u.indexOf('Safari') > -1
            };
        }(),
        language: (navigator.browserLanguage || navigator.language).toLowerCase()
    };
    useEffect(() => {
        const code = getParameter("code");
        if (code && browser.versions.weixin) {
            isRegister();
        }
    }, []);
    const openTodoApp = () => {
        if (browser.versions.weixin) {
            if (browser.versions.ios) {
                window.location.href = "https://www.kairusi.com/thinkdiary";
            } else if (browser.versions.android) {
                window.location.href = "https://www.kairusi.com/thinkdiary";
            }
        } else {
            if (browser.versions.android) {
                window.location.href = "rikeapp://rike.app/open";
                window.setTimeout(function () {
                    window.location.href = "https://www.kairusi.com/thinkdiary";
                }, 2000);
            } else if (browser.versions.ios) {
                window.location.href = "https://www.kairusi.com/thinkdiary";
            }
        }
    };
    const download = () => {
        if (browser.versions.weixin) {
            if (browser.versions.ios) {
                window.location.href = "https://itunes.apple.com/cn/app/id1551902709";
            } else if (browser.versions.android) {
                window.location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.kairos.todolist";
            }
        } else {
            if (browser.versions.android) {
                window.location.href = "http://download.kairusi.com/1TodoS/1TodoS.apk";
            } else if (browser.versions.ios) {
                window.location.href = "https://itunes.apple.com/cn/app/id1551902709";
            }
        }
    };
    // 微信授权
    const toWxpayAuth = () => {
        console.log(window.location.protocol + "//" + window.location.host + "/web/mobile#" + location.pathname + location.search);
        // window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${APPID}&redirect_uri=${encodeURIComponent("http://127.0.0.1:3000" + "/#" + location.pathname + location.search)}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${APPID}&redirect_uri=${encodeURIComponent("http://todo.kairusi.cn" + "/web/rike/mobile#" + location.pathname + location.search)}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
    };
    // 是否注册过
    const isRegister = () => {
        const code = getParameter("code");
        RikeService.checkRegister({ code }).then(res => {
            if (res.data.u_id === "0") {
                openTodoApp();
            } else {
                setUser(res.data);
                createOrder(res.data);
            }
        }).catch(error => { })
    };
    // 创建订单
    const createOrder = (userObject) => {
        const token = getParameter("token", location.search);
        RikeService.createOrder({ type: '5', u_id: userObject.u_id, openid: userObject.openid, share_token: token }).then(res => {
            setOrderData(res.data);
            localStorage.setItem("orderWx", JSON.stringify(res.data));
            toPay(res.data, userObject);
        }).catch(error => {
            error.message && Toast.info(error.message, 3);
            setTimeout(() => {
                window.location.replace("http://todo.kairusi.cn/web/rike/mobile/#/diaryDetail/" + params.id + "?token=" + token);
            }, 3000);
        })
    };
    // 查询订单
    const getOrderStatus = (userObject) => {
        const token = getParameter("token", location.search);
        RikeService.getOrderStatus({ order_sn: JSON.parse(localStorage.getItem("orderWx")).order_sn }).then(payInfo => {
            if (payInfo.data.status === 1) {
                clearInterval(timer);
                localStorage.removeItem("orderWx");
                Toast.info('支付成功', 2);
                setTimeout(() => {
                    window.location.replace("http://todo.kairusi.cn/web/rike/mobile/#/diaryDetail/" + params.id + "?token=" + token + "&noteUid=" + userObject.u_id);
                }, 2000);
            }
        }).catch(error => {
            error.message && Toast.info(error.message, 2);
            setTimeout(() => {
                localStorage.removeItem("noteUid");
                window.location.replace("http://todo.kairusi.cn/web/rike/mobile/#/diaryDetail/" + params.id + "?token=" + token);
            }, 2000);
        })
    };
    const onBridgeReady = (wxpayData, userObject) => {
        WeixinJSBridge.invoke(
            'getBrandWCPayRequest', {
            "appId": wxpayData.appid,     //公众号名称，由商户传入     
            "timeStamp": wxpayData.timestamp,         //时间戳，自1970年以来的秒数     
            "nonceStr": wxpayData.nonce_str, //随机串     
            // "package": "prepay_id=" + wxpayData.prepay_id,
            "package": wxpayData.package,
            "signType": "MD5",         //微信签名方式：     
            "paySign": wxpayData.sign //微信签名 
        },
            function (res) {
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                    if (localStorage.getItem("orderWx") && JSON.parse(localStorage.getItem("orderWx")).order_sn) {
                        setTimer(setInterval(() => {
                            getOrderStatus(userObject);
                        }, 1000))
                    }
                } else {
                    const token = getParameter("token", location.search);
                    localStorage.removeItem("orderWx");
                    window.location.replace("http://todo.kairusi.cn/web/rike/mobile/#/diaryDetail/" + params.id + "?token=" + token);
                }
            });
    };
    // 立即支付
    const toPay = (wxpayData, userObject) => {
        if (typeof WeixinJSBridge == "undefined") {
            if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', onBridgeReady(wxpayData, userObject), false);
            } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', onBridgeReady(wxpayData, userObject));
                document.attachEvent('onWeixinJSBridgeReady', onBridgeReady(wxpayData, userObject));
            }
        } else {
            onBridgeReady(wxpayData, userObject);
        }
    };
    return <div className={classnames("note-share rike-note-share")}>
        <div className="header">
            <div className="header-left">
                <img src={require("../image/rike/logo.png")} className="header-img" alt="" />
                <div className="header-text">日刻为您记录生活</div>
            </div>
            <div className="header-button" onClick={openTodoApp}>打开</div>
        </div>
        <div className={classnames("note-wrapper")}>
            {
                noteDetail.note.time_type === '1' //日反思
                && <div className="note-title note-day-title">
                    <p className="note-title-type">{moment(noteDetail.note.day).format('D')}</p>
                    <div className="note-day-right">
                        <p className="note-title-time">星期{getWeek(noteDetail.note.day)}</p>
                        <p className="note-title-time">{moment(noteDetail.note.day).format('YYYY年MM月')}</p>
                    </div>
                </div>
            }
            {
                noteDetail.note.time_type === '2' //周反思
                && <div className="note-title">
                    <p className="note-title-type">{noteDetail.note.day.split('W')[1]}周</p>
                    {/* <p className="note-title-time">{weekGetDate(Number(noteDetail.note.day.split('W')[0]), Number(noteDetail.note.day.split('W')[1]))}</p> */}
                    <p className="note-title-time">{weekDate(noteDetail.note.day.split('W').join('-')).join('-')}</p>
                </div>
            }
            {
                noteDetail.note.time_type === '3' //月反思
                && <div className="note-title">
                    <p className="note-title-type">{moment(noteDetail.note.day).format('M')}月</p>
                    <p className="note-title-time">{moment(noteDetail.note.day).format('YYYY')}</p>
                </div>
            }
            {
                noteDetail.note.time_type === '4' //年反思
                && <div className="note-title">
                    <p className="note-title-type">{noteDetail.note.day}</p>
                    {/* <p className="note-title-time">{noteDetail.note.day}~{noteDetail.note.day}</p> */}
                </div>
            }
            <div className="note-info-box">
                {
                    (noteDetail.note.expression || noteDetail.note.label_uuid)
                    && <div className="note-info-left">
                        {
                            noteDetail.note.expression
                            && <img src={require(`../image/rike/mood/${noteDetail.note.expression}.png`)} className="note-expression-img" />
                        }
                        {
                            noteDetail.note.label_uuid
                            && <span className="note-label">
                                <img src={require("../image/rike/label.png")} className="note-expression-img" />
                                <span className="note-label-text">{noteDetail.note.label_title}</span>
                            </span>
                        }
                    </div>
                }
                {
                    noteDetail.note.notebook_name
                    && <div className={classnames("note-info-right", { "note-info-no-left": !noteDetail.note.label_uuid && !noteDetail.note.expression })}>
                        <img src={require("../image/rike/diary.png")} className="note-diary-img" />
                        <span className="note-label-text note-diary-text">{noteDetail.note.notebook_name}</span>
                    </div>
                }
            </div>
            <div className="note-html">
                {
                    noteDetail.note_childs.map((el, i) => {
                        var imgReg = /<img.*?(?:>|\/>)/gi;
                        var arr = el.content_h5.match(imgReg);
                        if (!el.content && (!arr || (arr && arr.length <= 0))) {
                            return;
                        }
                        return <div className="note-html-item" key={i}>
                            <div className="note-html-title">{el.note_child_title}</div>
                            <div className="note-html-box" dangerouslySetInnerHTML={{ __html: el.content_h5.replace(/thinking:\/\//g, "https://kairusi.oss-cn-hangzhou.aliyuncs.com/think/upload/") }} />
                        </div>
                    })
                }
            </div>
        </div>
    </div>
};

export default RikeNoteShare;